import axios from 'axios';
import { SERVER_URL } from './constants.service';

export function getEnrollmentStatus() {
  const filter = {
    where: {
      name: 'ENROLLMENT'
    }
  };

  return axios.get(`${SERVER_URL}/api/Settings/findOne`, {
    params: { filter }
  })
    .then(({ data }) => data);
}

export function updateEnrollmentStatus(id, value) {
  return axios.patch(`${SERVER_URL}/api/Settings/${id}`, { value })
    .then(({ data }) => data);
}

export default { getEnrollmentStatus, updateEnrollmentStatus };



// WEBPACK FOOTER //
// ./src/modules/services/enrollment.service.js